import { Platform } from '@angular/cdk/platform';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {
  Page451FontsExtractorService,
  SerializablePage451Component
} from '@element451-libs/page451-lib';
import {
  BillboardAppRowLayoutProxy,
  tokensConfig
} from '@element451-libs/page451-rows';
import { FontService } from '@element451-libs/utils451/font';
import { map, take } from 'rxjs/operators';
import { AccountService, SiteService } from '../../../+state';

@Component({
  selector: 'elm-app-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit {
  components$ = this.site.components$;

  @ViewChild('headerTmpl', { static: true }) headerTmpl: TemplateRef<any>;
  @ViewChild('panelTmpl', { static: true }) panelTmpl: TemplateRef<any>;

  constructor(
    private site: SiteService,
    private accountService: AccountService,
    private layoutProxy: BillboardAppRowLayoutProxy,
    private platform: Platform,
    private fontService: FontService,
    private fontExtractor: Page451FontsExtractorService
  ) {}

  ngOnInit() {
    // Assign templates
    this.layoutProxy.headerTplRef = this.headerTmpl;
    this.layoutProxy.mainTplRef = this.panelTmpl;
    this.layoutProxy.showTemplates$ = this.accountService.isAuthorized$;

    if (this.platform.isBrowser) {
      this.components$
        .pipe(
          take(1),
          map(components =>
            this.fontExtractor.extract(components, tokensConfig)
          )
        )
        .subscribe(fonts => this.fontService.loadFonts(fonts));
    }
  }

  trackByComponentGuid(index: number, row: SerializablePage451Component) {
    return row.pageGuid;
  }
}
